import { css } from 'emotion';
import { styles as s } from '@onehope/design-system-ohw';

const { cssConstants } = s;

export const container = css`
  text-align: center;
  font-family: ${cssConstants.font};
  margin: 40px 16px;
  @media screen and (min-width: 1440px) {
    margin: 64px 16px;
  }
`;
